import { Box, Button, Stack, TextField } from "@mui/material";
import React, { useState } from "react";
import AddressComp, { Address } from "../addressComp/AddressComp";
import { LoadingButton } from "@mui/lab";
import "./styles.scss";
import { PartnershipType } from "../../types/genericType";
import { useSelector } from "react-redux";
import {
  createPartnership,
  editPartnership,
} from "../../services/partnershipService";

type NewPartnershipPropType = {
  getPartnershipsData: Function;
  handleDrawerClose: Function;
  isActive: boolean;
  editFlow: boolean;
  setOnTxnSuccess: Function;
  setSnackbarMsg: Function;
};

const NewPartnership = (props: NewPartnershipPropType) => {
  const {
    getPartnershipsData,
    handleDrawerClose,
    isActive,
    editFlow,
    setOnTxnSuccess,
    setSnackbarMsg,
  } = props;
  const { selectedPartnership } = useSelector(
    (state: any) => state.partnershipsState
  );
  const [partnershipName, setPartnershipName] = useState<string | null>(
    selectedPartnership?.name ?? ""
  );
  const [address, setAddress] = useState<Address>({
    address: selectedPartnership?.address ?? "",
    apartment: selectedPartnership?.apartment ?? "",
    city: selectedPartnership?.city ?? "",
    state: selectedPartnership?.state ?? "",
    zip: selectedPartnership?.zip ?? "",
    country: selectedPartnership?.country ?? "",
  });
  const [description, setDescription] = useState<string | null>(
    selectedPartnership?.description ?? ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleCreatePartnership = () => {
    setIsLoading(true);
    const data: PartnershipType = {
      name: partnershipName ?? "",
      description: description ?? "",
      isActive,
      ...address,
    };
    createPartnership(data)
      .then(() => {
        handleDrawerClose();
        setIsLoading(false);
        setOnTxnSuccess(true);
        getPartnershipsData();
        setSnackbarMsg("Partnership created successfully");
      })
      .catch(() => {
        setIsLoading(false);
        setSnackbarMsg("Error creating partnership");
      });
  };

  const handleEditPartnership = () => {
    setIsLoading(true);
    const data: PartnershipType = {
      name: partnershipName ?? "",
      description: description ?? "",
      isActive,
      ...address,
      id: selectedPartnership.id,
    };
    editPartnership(data)
      .then(() => {
        handleDrawerClose();
        setIsLoading(false);
        setOnTxnSuccess(true);
        getPartnershipsData();
        setSnackbarMsg("Partnership updated successfully");
      })
      .catch(() => {
        setIsLoading(false);
        setSnackbarMsg("Error updating partnership");
      });
  };

  return (
    <Box className="new-transaction">
      <Stack spacing={3}>
        <TextField
          id="outlined-helperText"
          label="Partnership Name"
          size="small"
          value={partnershipName}
          onChange={(event: { target: { value: string } }) =>
            setPartnershipName(event.target.value as string)
          }
          fullWidth
        />
        <AddressComp address={address} setAddress={setAddress} />
        <TextField
          id="outlined-helperText"
          label="Description "
          size="small"
          value={description}
          onChange={(event: { target: { value: string } }) =>
            setDescription(event.target.value as string)
          }
          fullWidth
        />
      </Stack>
      <Stack direction="row" spacing={2} className="action-buttons">
        <LoadingButton
          variant="contained"
          data-testid="createTxnBtn"
          size="small"
          className="create-button"
          onClick={editFlow ? handleEditPartnership : handleCreatePartnership}
          loading={isLoading}
        >
          {editFlow ? "SAVE CHANGES" : "Create Partnership"}
        </LoadingButton>
        <Button className="cancel-button" onClick={() => handleDrawerClose()}>
          CANCEL
        </Button>
      </Stack>
    </Box>
  );
};

export default NewPartnership;
